import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button, Col, Form, Input, InputNumber, Row } from 'antd';
import generator from 'generate-password-browser';

import clientActions from '../../../client/actions';
import CLIENT from '../../../client/actionTypes';

import { AppDispatch } from '../../../../types/app';

type FormValues = {
  Code: string;
  PasswordNew: string;
  PasswordNewConfirm: string;
};

type Props = {
  readyStatus: string;
  email: string;
};

const FormPassword = ({ readyStatus, email }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  const dispatch = useDispatch<AppDispatch>();

  const generatePassword = () => {
    const password = generator.generate({
      length: 12,
      numbers: true,
    });

    form.setFieldsValue({
      PasswordNew: password,
      PasswordNewConfirm: password,
    });
  };

  const handleSubmit = ({ Code, PasswordNew }: FormValues) => {
    dispatch(clientActions.RecoveryPassword.changePassword(Code, PasswordNew));
  };

  const isRequesting =
    readyStatus === CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.REQUESTING;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      disabled={isRequesting}
    >
      <Form.Item label={intl.formatMessage({ id: 'profile.field.Email' })}>
        <Input disabled value={email} />
      </Form.Item>

      <Form.Item
        name="Code"
        label={intl.formatMessage({ id: 'client.confirm.code' })}
        rules={[{ required: true, type: 'number' }]}
      >
        <InputNumber autoFocus className="profile-recovery__code-input" />
      </Form.Item>

      <Row gutter={[16, 8]} align="middle">
        <Col xs={24} sm={16}>
          <Form.Item
            label={intl.formatMessage({ id: 'profile.password.new' })}
            name="PasswordNew"
            rules={[{ required: true }, { type: 'string', min: 5 }]}
          >
            <Input.Password visibilityToggle />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Button
            onClick={generatePassword}
            className="profile-form__generate-btn"
            tabIndex={-1}
          >
            {intl.formatMessage({ id: 'buttons.generate' })}
          </Button>
        </Col>
      </Row>

      <Form.Item
        label={intl.formatMessage({ id: 'profile.password.repeat' })}
        name="PasswordNewConfirm"
        dependencies={['PasswordNew']}
        rules={[
          { required: true },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('PasswordNew') === value) {
                return Promise.resolve();
              }

              return Promise.reject(
                intl.formatMessage({ id: 'error.MatchField' })
              );
            },
          }),
        ]}
      >
        <Input.Password visibilityToggle={false} />
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={isRequesting}>
        {intl.formatMessage({ id: 'buttons.submit' })}
      </Button>
    </Form>
  );
};

export default FormPassword;
